<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-book"></i> StandBy Lesson Changes</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column">
                <lessons-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged"  @approve="approvedChanges" @decline="declinedChanges" :total="total" v-bind:items="lessons" v-bind:actions="true"></lessons-table>
            </div>
        </div>
    </div>
</template>

<script>
import LessonsTable from "./Table";

export default {
  name: 'sb-lessons-view',
  components: {LessonsTable},
  data() {
        return {
            lessons: [],
            total: 0,
            search: {'query':'', school:{}, status:'requested'},
            orderBy: 'id,asc',
            page: 1,
        }
  },
  created(){
    this.getLessons();
  },
  methods: {
    onSearch(search){
        this.page = 1;
        this.search = search;
        this.getLessons();
    },
      approvedChanges(id){
          this.lessons.forEach(lesson => {
              if(lesson.id == id){
                  lesson.status = "approved";
              }
          })
      },
      declinedChanges(id){
          this.lessons.forEach(lesson => {
              if(lesson.id == id){
                  lesson.status = "declined";
              }
          })
      },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getLessons();
    },
    onPageChanged(page){
        this.page = page;
        this.getLessons();
    },
    getLessons(){
        let searchData = Object.assign(this.search, {page:this.page, orderBy:this.orderBy})
        
        this.stbyLessonRepo.paginateChanges(searchData).then(response => {
            console.log(response.data.data);
            this.lessons = response.data.data;
            this.total = response.data.meta.pagination.total_pages
        });
    },
  },
  watch: {

  }

}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sb-lesson-changes/View.vue